import { I as l } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as r, normalizeClass as o, createStaticVNode as s } from "vue";
import { _ as n } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const h = {
  name: "DtIconGoogleMeet",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (t) => Object.keys(l).includes(t)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return l[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, p = ["aria-label", "data-qa", "aria-hidden"];
function c(t, e, i, f, m, a) {
  return d(), r("svg", {
    "aria-label": i.ariaLabel,
    class: o([a.iconSizeClass, "d-icon d-icon--google-meet"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Google Meet",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...e[0] || (e[0] = [
    s('<path d="M1.5 8.5v7L4 16l2.5-.5v-7L4 8l-2.5.5Z" fill="#1E88E5"></path><path d="M18.5 12v7a1.5 1.5 0 0 1-1.5 1.5H6.5L6 18l.5-2.5h7V12l2.5-.5 2.5.5Z" fill="#4CAF50"></path><path d="M18.5 5v7h-5V8.5h-7L6 6l.5-2.5H17A1.5 1.5 0 0 1 18.5 5Z" fill="#FBC02D"></path><path d="M6.5 15.5v5H3A1.5 1.5 0 0 1 1.5 19v-3.5h5Z" fill="#1565C0"></path><path d="M6.5 3.5v5h-5l5-5Z" fill="#E53935"></path><path d="m19 12-.5 4.225-5-4.225 5-4.225L19 12Z" fill="#2E7D32"></path><path d="M23 5.055v13.89c0 .42-.49.655-.815.39l-3.685-3.11v-8.45l3.685-3.11a.501.501 0 0 1 .815.39Z" fill="#4CAF50"></path>', 7)
  ])], 10, p);
}
const g = /* @__PURE__ */ n(h, [["render", c]]);
export {
  g as default
};
//# sourceMappingURL=google-meet.js.map
